module.exports = __webpack_public_path__ + "img/face_gather7.3c10ef8c.png";